var _rect, _path, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeletemember(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1649_4622",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 47,
    height: 47
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1649_4622)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 22.8978C21.6151 22.8978 20.0016 22.2267 18.6595 20.8846C17.3171 19.5422 16.6458 17.9285 16.6458 16.0436C16.6458 14.1587 17.3171 12.5452 18.6595 11.2031C20.0016 9.86067 21.6151 9.18945 23.5 9.18945C25.3849 9.18945 26.9984 9.86067 28.3405 11.2031C29.6829 12.5452 30.3542 14.1587 30.3542 16.0436C30.3542 17.9285 29.6829 19.5422 28.3405 20.8846C26.9984 22.2267 25.3849 22.8978 23.5 22.8978ZM8.8125 37.8115V33.4576C8.8125 32.4987 9.07296 31.6106 9.59388 30.7933C10.1148 29.976 10.811 29.3477 11.6824 28.9084C13.6179 27.9596 15.5705 27.2479 17.5403 26.7733C19.5101 26.2988 21.4966 26.0615 23.5 26.0615C25.5034 26.0615 27.4899 26.2988 29.4597 26.7733C31.4295 27.2479 33.3821 27.9596 35.3176 28.9084C36.189 29.3477 36.8852 29.976 37.4061 30.7933C37.927 31.6106 38.1875 32.4987 38.1875 33.4576V37.8115H8.8125ZM11.75 34.874H35.25V33.4576C35.25 33.061 35.1351 32.6939 34.9053 32.356C34.6756 32.0186 34.3637 31.7431 33.9697 31.5296C32.2823 30.6986 30.5619 30.069 28.8086 29.6408C27.0549 29.2129 25.2853 28.999 23.5 28.999C21.7147 28.999 19.9451 29.2129 18.1914 29.6408C16.4381 30.069 14.7177 30.6986 13.0303 31.5296C12.6363 31.7431 12.3244 32.0186 12.0947 32.356C11.8649 32.6939 11.75 33.061 11.75 33.4576V34.874ZM23.5 19.9603C24.5771 19.9603 25.4991 19.5768 26.2661 18.8098C27.0332 18.0428 27.4167 17.1207 27.4167 16.0436C27.4167 14.9665 27.0332 14.0445 26.2661 13.2775C25.4991 12.5105 24.5771 12.127 23.5 12.127C22.4229 12.127 21.5009 12.5105 20.7339 13.2775C19.9668 14.0445 19.5833 14.9665 19.5833 16.0436C19.5833 17.1207 19.9668 18.0428 20.7339 18.8098C21.5009 19.5768 22.4229 19.9603 23.5 19.9603Z",
    fill: "#FF4D4D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1649_4622",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 1,
    width: 14,
    height: 13
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.5,
    y: 1,
    width: 13,
    height: 13,
    fill: "#FF4C4C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1649_4622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0513 10.0211L38.0013 8.07111L39.9513 10.0211L40.5221 9.45033L38.5721 7.50033L40.5221 5.55033L39.9513 4.97954L38.0013 6.92954L36.0513 4.97954L35.4805 5.55033L37.4305 7.50033L35.4805 9.45033L36.0513 10.0211ZM38.0023 12.6462C37.2905 12.6462 36.6215 12.5111 35.9952 12.241C35.369 11.9709 34.8242 11.6043 34.361 11.1413C33.8978 10.6782 33.5311 10.1337 33.2608 9.50774C32.9906 8.88176 32.8555 8.21293 32.8555 7.50127C32.8555 6.78952 32.9905 6.12052 33.2606 5.49426C33.5307 4.86801 33.8973 4.32327 34.3604 3.86005C34.8234 3.39684 35.3679 3.03009 35.9939 2.75979C36.6199 2.48959 37.2887 2.35449 38.0004 2.35449C38.7121 2.35449 39.3811 2.48955 40.0074 2.75966C40.6336 3.02977 41.1784 3.39634 41.6416 3.85938C42.1048 4.32241 42.4715 4.86692 42.7418 5.49291C43.012 6.1189 43.1471 6.78772 43.1471 7.49938C43.1471 8.21113 43.0121 8.88013 42.742 9.50639C42.4719 10.1326 42.1053 10.6774 41.6423 11.1406C41.1792 11.6038 40.6347 11.9706 40.0087 12.2409C39.3827 12.5111 38.7139 12.6462 38.0023 12.6462Z",
    fill: "#FF4C4C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletemember);
export default __webpack_public_path__ + "static/media/deletemember.30dca2d0704c850eb680ff1515b49f2f.svg";
export { ForwardRef as ReactComponent };